import { collection, doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * Debug utility to log the engagement share percentage for a specific user and date
 */
export async function logEngagementSharePercentage(username: string, date: string) {
  try {
    // Path to the specific document
    const docRef = doc(db, 'user_engagement_history', username, '7_day_engagement', date);
    
    // Get the document
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      const data = docSnap.data();
      console.log(`Engagement data for ${username} on ${date}:`, data);
      // Use bracket notation to access property with a number at the start
      console.log(`7_day_score: ${data['7_day_score']}`);
      console.log(`engagement_share_percentage: ${data.engagement_share_percentage}`);
      return data.engagement_share_percentage;
    } else {
      console.log(`No engagement data found for ${username} on ${date}`);
      return null;
    }
  } catch (error) {
    console.error('Error fetching engagement data:', error);
    return null;
  }
}

/**
 * Debug utility to log all fields in a document
 */
export async function logDocumentFields(collectionPath: string, docId: string) {
  try {
    const docRef = doc(db, collectionPath, docId);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      console.log(`Document data for ${collectionPath}/${docId}:`, docSnap.data());
      return docSnap.data();
    } else {
      console.log(`No document found at ${collectionPath}/${docId}`);
      return null;
    }
  } catch (error) {
    console.error('Error fetching document:', error);
    return null;
  }
}